import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout'
import Layout_en from '@/views/layout_en'
import Layout_pork from '@/views/layout_pork'
import Layout_pork_en from '@/views/layout_pork_en'
import Share from '@/views/sharepage'
import ShareDownload from '@/views/sharedownload'
import ShareDownloadAndroid from '@/views/share_download_android'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    { path: '/index.html', redirect: '/BTCInfo' },
    { path: '/', redirect: '/BTCInfo' },
    /** ******************************************** 中文版 ******************************************** **/
    // 分享页面
    {
      path: '/share/:id',
      component: Share,
      name: 'share',
      children: [{
        path: '',
        component: () => import('@/views/sharepage')
      }]
    },
    // 分享下载
    {
      path: '/btc',
      component: ShareDownload,
      children: [{
        path: '',
        component: () => import('@/views/sharedownload')
      }]
    },
    // 分享下载
    {
      path: '/sharedownload',
      component: ShareDownloadAndroid,
      children: [{
        path: '',
        component: () => import('@/views/share_download_android')
      }]
    },
    // 注册
    {
      path: '/signup',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/signup/CN')
      }]
    },
    // 必孚动态
    {
      path: '/BTCTrend',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/beeftrend')
      }]
    },
    // 必孚资讯
    {
      path: '/BTCInfo',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/beefinfo')
      }]
    },
    // 必孚数据-牛肉
    {
      path: '/BTCData',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/beefbigdata/newIndex')
      }]
    },
    {
      path: '/BTCData/BeefExportToChina',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/beefbigdata/chart/beefIndustryData')
      }]
    },
    {
      path: '/BTCData/GlobalBeefExport',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/beefbigdata/chart/globalBeefExport')
      }]
    },
    {
      path: '/BTCData/ChinaBeefImportDataChart',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/beefbigdata/chart/customChart')
      }]
    },
    {
      path: '/BTCData/ChinaBeefImportDataReport',
      component: Layout,
      children: [{
        path: '',
        name: 'ChinaBeefImportDataReport',
        component: () => import('@/views/beefbigdata/chart/customReport')
      }]
    },
    {
      path: '/BTCPlant',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/beefbigdata/chart/approvePlant')
      }]
    },
    // 必孚数据-猪肉
    // 必孚数据
    {
      path: '/Pork/PTCData',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/beefbigdata/porkindex')
      }]
    },
    // 必孚行情
    {
      path: '/BTCPrice',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/beefindex')
      }]
    },
    // 文章详情
    {
      path: '/article/:id',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/components/NewsDetail')
      }]
    },
    // 行情周报详情
    {
      path: '/article/price/:id',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/beefindex/components/report-detail')
      }]
    },
    // 周市详情
    {
      path: '/article/weeks/:id',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/beefindex/components/report-news')
      }]
    },
    // 新闻列表
    {
      path: '/section',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/components/NewsList')
      }]
    },
    // 充值页面
    {
      path: '/charge',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/charge/CN')
      }]
    },
    // 个人中心
    {
      path: '/account',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/layout/components/PersonalCenter/newindex')
      }]
    },
    // 忘记密码
    {
      path: '/forget_passwd',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/forgetpasswd')
      }]
    },
    // 忘记密码
    {
      path: '/reset_password',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/resetpassword')
      }]
    },
    // 搜索
    {
      path: '/search',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/components/GlobalSearch')
      }]
    },
    // 必孚肉集
    {
      path: '/BTCMarket',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/beefmarket')
      }]
    },
    // 必孚代理金融
    {
      path: '/BTCFinancial',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/beefthirdservice/beeffinancial')
      }]
    },
    // 必孚代理采销
    {
      path: '/BTCSale',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/beefthirdservice/beefsale')
      }]
    },
    /** ******************************************** 英文版 ******************************************** **/
    // Register
    {
      path: '/english/signup',
      component: Layout_en,
      children: [{
        path: '',
        component: () => import('@/views/signup/EN')
      }]
    },
    // BTC Info
    {
      path: '/english/BTCInfo',
      component: Layout_en,
      children: [{
        path: '',
        component: () => import('@/views/btchub')
      }]
    },
    // BTC Data
    {
      path: '/english/BTCData',
      component: Layout_en,
      children: [{
        path: '',
        component: () => import('@/views/btcdata/newIndex')
      }]
    },
    {
      path: '/english/BTCData/BeefExportToChina',
      component: Layout_en,
      children: [{
        path: '',
        component: () => import('@/views/btcdata/chart/beefIndustryData')
      }]
    },
    {
      path: '/english/BTCData/GlobalBeefExports',
      component: Layout_en,
      children: [{
        path: '',
        component: () => import('@/views/btcdata/chart/globalBeefExport')
      }]
    },
    {
      path: '/english/BTCData/ChinaBeefImportDataChart',
      component: Layout_en,
      children: [{
        path: '',
        component: () => import('@/views/btcdata/chart/customChart')
      }]
    },
    {
      path: '/english/BTCData/ChinaBeefImportDataReport',
      component: Layout_en,
      children: [{
        path: '',
        component: () => import('@/views/btcdata/chart/customReport')
      }]
    },
    {
      path: '/english/BTCPlant',
      component: Layout_en,
      children: [{
        path: '',
        component: () => import('@/views/btcdata/chart/approvePlant')
      }]
    },
    // BTC Price
    {
      path: '/english/BTCPrice',
      component: Layout_en,
      children: [{
        path: '',
        component: () => import('@/views/btcprice')
      }]
    },
    // BTC Market
    {
      path: '/english/BTCMarket',
      component: Layout_en,
      children: [{
        path: '',
        component: () => import('@/views/btcmarket')
      }]
    },
    // BTC Market Importers
    {
      path: '/english/BTCMarket/Importers',
      component: Layout_en,
      children: [{
        path: '',
        component: () => import('@/views/btcmarket/importers')
      }]
    },
    // Article Detail
    {
      path: '/english/article/:id',
      component: Layout_en,
      children: [{
        path: '',
        component: () => import('@/components/NewsDetail')
      }]
    },
    // News List
    {
      path: '/english/section',
      component: Layout_en,
      children: [{
        path: '',
        component: () => import('@/components/NewsList')
      }]
    },
    // Charge Page
    {
      path: '/english/charge',
      component: Layout_en,
      children: [{
        path: '',
        component: () => import('@/views/charge/EN')
      }]
    },
    // Personal center
    {
      path: '/english/account',
      component: Layout_en,
      children: [{
        path: '',
        component: () => import('@/views/layout_en/components/PersonalCenter')
      }]
    },
    // forget password
    {
      path: '/english/forget_passwd',
      component: Layout_en,
      children: [{
        path: '',
        component: () => import('@/views/forgetpasswd')
      }]
    },
    // reset password
    {
      path: '/english/reset_password',
      component: Layout_en,
      children: [{
        path: '',
        component: () => import('@/views/resetpassword')
      }]
    },
    // search
    {
      path: '/english/search',
      component: Layout_en,
      children: [{
        path: '',
        component: () => import('@/components/GlobalSearch')
      }]
    },
    // 英文版行情周报详情
    {
      path: '/english/article/price/:id',
      component: Layout_en,
      children: [{
        path: '',
        component: () => import('@/views/btcprice/components/report-detail')
      }]
    },
    // ----------------------------------------------------------------破壳中文----------------------------------------------------------
    {
      path: '/Pork/PTCInfo',
      component: Layout_pork,
      children: [{
        path: '',
        component: () => import('@/views/porkcn/porkinfo')
      }]
    },
    {
      path: '/Pork/PTCData/PorkExportToChina',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/porkcn/porkdata/export_to_china')
      }]
    },
    {
      path: '/Pork/PTCData/GlobalPorkExports',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/porkcn/porkdata/global_pork_exports')
      }]
    },
    {
      path: '/Pork/PTCData/ChinaPorkImports',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/porkcn/porkdata/china_pork_imports')
      }]
    },
    {
      path: '/Pork/PTCEst',
      component: Layout,
      children: [{
        path: '',
        component: () => import('@/views/porkcn/porkplant')
      }]
    },
    {
      path: '/Pork/PorkSection',
      component: Layout_pork,
      children: [{
        path: '',
        component: () => import('@/components/NewsList')
      }]
    },
    {
      path: '/Pork/PorkArticle/:id',
      component: Layout_pork,
      children: [{
        path: '',
        component: () => import('@/components/NewsDetail')
      }]
    },
    {
      path: '/Pork/PorkSearch',
      component: Layout_pork,
      children: [{
        path: '',
        component: () => import('@/components/GlobalSearch')
      }]
    },
    {
      path: '/Pork/PTCAccount',
      component: Layout_pork,
      children: [{
        path: '',
        component: () => import('@/views/layout_pork/components/PersonalCenter')
      }]
    },
    {
      path: '/Pork/PTCCharge',
      component: Layout_pork,
      children: [{
        path: '',
        component: () => import('@/views/charge/CN')
      }]
    },
    {
      path: '/Pork/PTCRegister',
      component: Layout_pork,
      children: [{
        path: '',
        component: () => import('@/views/signup/CN')
      }]
    },
    // ----------------------------------------------------------------破壳英文----------------------------------------------------------
    {
      path: '/Pork/English/PTCInfo',
      component: Layout_pork_en,
      children: [{
        path: '',
        component: () => import('@/views/porken/porkinfo')
      }]
    },
    {
      path: '/Pork/English/PTCData/PorkExportToChina',
      component: Layout_pork_en,
      children: [{
        path: '',
        component: () => import('@/views/porken/porkdata/export_to_china')
      }]
    },
    {
      path: '/Pork/English/PTCData/GlobalPorkExports',
      component: Layout_pork_en,
      children: [{
        path: '',
        component: () => import('@/views/porken/porkdata/global_pork_exports')
      }]
    },
    {
      path: '/Pork/English/PTCData/ChinaPorkImports',
      component: Layout_pork_en,
      children: [{
        path: '',
        component: () => import('@/views/porken/porkdata/china_pork_imports')
      }]
    },
    {
      path: '/Pork/English/PTCEst',
      component: Layout_pork_en,
      children: [{
        path: '',
        component: () => import('@/views/porken/porkplant')
      }]
    },
    {
      path: '/Pork/English/PorkSection',
      component: Layout_pork_en,
      children: [{
        path: '',
        component: () => import('@/components/NewsList')
      }]
    },
    {
      path: '/Pork/English/PorkArticle/:id',
      component: Layout_pork_en,
      children: [{
        path: '',
        component: () => import('@/components/NewsDetail')
      }]
    },
    {
      path: '/Pork/English/PorkSearch',
      component: Layout_pork_en,
      children: [{
        path: '',
        component: () => import('@/components/GlobalSearch')
      }]
    },
    {
      path: '/Pork/English/PTCAccount',
      component: Layout_pork_en,
      children: [{
        path: '',
        component: () => import('@/views/layout_pork_en/components/PersonalCenter')
      }]
    },
    {
      path: '/Pork/English/PTCCharge',
      component: Layout_pork_en,
      children: [{
        path: '',
        component: () => import('@/views/charge/EN')
      }]
    },
    {
      path: '/Pork/English/PTCRegister',
      component: Layout_pork_en,
      children: [{
        path: '',
        component: () => import('@/views/signup/EN')
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js